/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Button, MenuItem, Select, Modal, Box, TextField } from "@mui/material";
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import usePermission from "../../hooks/usePermission";
import useTranslation from "../../hooks/traslation";
import { RefundData } from "../../types/General";
import moment from "moment";

interface CustomerPendingIssuesProps {
  rows: RefundData[];
  page: number;
  handleChange: (event: any, newPage: number) => void;
  loading: boolean;
  count: number;
  
}

const CustomerPendingIssues = ({
  rows,
  page,
  handleChange,
  loading,
  count,
  
}: CustomerPendingIssuesProps) => {
  const navigate = useNavigate();
  const translation = useTranslation();
  const { isAdd, isDelete } = usePermission({
    label: "Manage Refunds",
    page_permission: "isView",
  });

  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 1,
      minWidth: 200,
      field: "employerId",
      headerName: translation.main.employerDetail,
      editable: false,
      sortable: false,
      renderCell: (params) => {
        return (
          <div
            className="user_block click_action"
            onClick={() =>
              navigate(
                `/manage-employers/detail/${params?.row?.employerId?._id}`
              )
            }
          >
            <figure>
              <img
                src={
                  params?.row?.employerId?.image ||
                  "/static/images/user_placeholder.png"
                }
                alt=""
              />
            </figure>
            <p>
              <b>{`${params?.row?.employerId?.firstName} ${params?.row?.employerId?.lastName}`}</b>
              <span>{params?.row?.employerId?.email}</span>
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 200,
      field: "freelancerId",
      headerName: translation.main.freelancerDetail,
      editable: false,
      sortable: false,
      renderCell: (params) => {
        return (
          <div
            className="user_block click_action"
            onClick={() =>
              navigate(
                `/manage-freelancer/detail/${params?.row?.freelancerId?._id}`
              )
            }
          >
            <figure>
              <img
                src={
                  params?.row?.freelancerId?.image ||
                  "/static/images/user_placeholder.png"
                }
                alt=""
              />
            </figure>
            <p>
              <b>{`${params?.row?.freelancerId?.firstName} ${params?.row?.freelancerId?.lastName}`}</b>
              <span>{params?.row?.freelancerId?.email}</span>
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 250,
      field: "categoryId",
      headerName: "Category",
      editable: false,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="user_block">
            <p>{params?.row.categoryId.name}</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 200,
      field: "subCategoryId",
      headerName: "Sub Service",
      editable: false,
      sortable: false,
      renderCell: (params) => {
        return params.row.subCategoryId.name;
      },
    },
    {
      flex: 1,
      minWidth: 120,
      field: "createdAt",
      headerName: translation.main.dateTime,
      editable: false,
      sortable: false,
      renderCell: (params) => {
        return moment(params.row.createdAt).format("DD MMM YYYY, hh:mm A");
      },
    },
    {
      flex: 1,
      minWidth: 120,
      field: "bookingId",
      headerName: translation.main.Amount,
      editable: false,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <p className="c_success">
            <strong>AED {params.row.bookingId.total}</strong>
          </p>
        );
      },
    },
    {
      flex: 1,
      minWidth: 120,
      field: "offers",
      headerName: translation.user.Actions,
      editable: false,
      sortable: false,
      renderCell: (params) => {
        return (
          <Button
            className="btn sm btn_primary"
            onClick={() =>
              navigate(
                `/manage-dispute-refunds/offers/${params?.row?.bookingId?._id}/${params?.row?.status}`
              )
            }
          >
            {translation.globals.View}
          </Button>
        );
      },
    },
  ];

  return (
    <>
      <div className="sorting_table">
        <TableComponent
          columns={columns}
          rows={rows}
          loading={loading}
          count={count}
          page={page}
          onPageChange={handleChange}
        />
      </div>
    </>
  );
};

export default CustomerPendingIssues;
